import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PageLoader } from '../components/PageLoader';
import {
  AuthCallback,
  LoginPage,
  RegistrationPage,
  ForgotPasswordPage,
  EmailVerificationPage,
  GoogleOAuthSuccess,
  PendingVerification,
  OnboardingPage,
} from './lazyPages';
import { dashboardRouteElements } from './dashboardRoutes';
import {
  BookingsRedirect,
  NetworkAnalyticsRedirect,
  NetworkCalendarRedirect,
  NetworkRedirect,
  ProfileRedirect,
} from './redirects';
import { RouteErrorBoundary } from '../../shared/components/common/RouteErrorBoundary';

function lazyRoute(element: React.ReactNode) {
  return (
    <RouteErrorBoundary>
      <Suspense fallback={<PageLoader />}>{element}</Suspense>
    </RouteErrorBoundary>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Auth */}
      <Route path="/login" element={lazyRoute(<LoginPage />)} />
      <Route path="/signup" element={lazyRoute(<RegistrationPage />)} />
      <Route path="/forgot-password" element={lazyRoute(<ForgotPasswordPage />)} />
      <Route path="/verify-email" element={lazyRoute(<EmailVerificationPage />)} />
      <Route path="/oauth/google/success" element={lazyRoute(<GoogleOAuthSuccess />)} />
      <Route path="/auth-callback" element={lazyRoute(<AuthCallback />)} />

      {/* Onboarding (post-login, before dashboard) */}
      <Route path="/onboarding" element={lazyRoute(<OnboardingPage />)} />
      <Route path="/pending-verification" element={lazyRoute(<PendingVerification />)} />

      {dashboardRouteElements}

      <Route path="/resume-review" element={<Navigate to="/jobseeker-dashboard/resume-review" replace />} />
      <Route path="/culture-call" element={<Navigate to="/jobseeker-dashboard/mock-interview" replace />} />
      <Route path="/mock-interview" element={<Navigate to="/jobseeker-dashboard/mock-interview" replace />} />
      <Route path="/referral-session" element={<Navigate to="/jobseeker-dashboard/referral-session" replace />} />

      <Route path="/bookings" element={<BookingsRedirect />} />
      <Route path="/my-sessions" element={<BookingsRedirect />} />
      <Route path="/profile" element={<ProfileRedirect />} />

      <Route path="/services" element={<Navigate to="/referral-dashboard/services" replace />} />
      <Route path="/network-page" element={<NetworkRedirect />} />
      <Route path="/network" element={<NetworkRedirect />} />
      <Route path="/network-page/calendar" element={<NetworkCalendarRedirect />} />
      <Route path="/network/analytics" element={<NetworkAnalyticsRedirect />} />
      <Route path="/analytics/withdrawal" element={<Navigate to="/referral-dashboard/analytics/withdrawal" replace />} />

      <Route path="/interview-prep" element={<Navigate to="/jobseeker-dashboard/mock-interview" replace />} />
      <Route path="/service" element={<Navigate to="/referral-dashboard/services" replace />} />

      <Route path="/payouts" element={<ProfileRedirect />} />
      <Route path="/network/payout" element={<ProfileRedirect />} />
      <Route path="/wallet-recharge" element={<ProfileRedirect />} />

      <Route path="/job-openings" element={<Navigate to="/jobseeker-dashboard/jobopenings" replace />} />
      <Route path="/network/job-opening" element={<Navigate to="/jobseeker-dashboard/jobopenings" replace />} />

      <Route path="/" element={<Navigate to="/signup" replace />} />
      <Route path="*" element={<Navigate to="/signup" replace />} />
    </Routes>
  );
}
